import { upload } from './http';

export const uploadFile = file => {
	let fileInput;

	return new Promise(resolve => {
		const uploader = file => {
			if (file) {
				const fileName = file.name;
				const formData = new FormData();
				formData.append('files[]', file, fileName);
				formData.append('bid', window.$store.state.bot?.id || window.$store.state.bid || 0);
				upload('/api/file', formData, {
					'Authorization': 'Token ' + window.$store.state.auth_token
				}, { useRoot: true }).then(result => {
					resolve(result[0].name);
				})
				// .catch(ex => {
				// 	resolve('https://anybot-dev.s3.amazonaws.com/787_1635210699_0.jpeg');
				// });
			} else {
				resolve();
			}

			if(fileInput) {
				fileInput.remove();
				fileInput = undefined;
			}
		}

		if (!file) {
			fileInput = document.createElement('input');
			fileInput.style.display = 'none';
			fileInput.type = 'file';
			fileInput.addEventListener('change', () => {
				const file = fileInput.files?.[0];
				if (file) {
					uploader(file);
				}
			}, false);

			document.body.insertAdjacentElement('beforeend', fileInput);
			fileInput.click();
		} else {
			uploader(file);
		}
	});
}

export const uploadFileReact = (file, reaction, accessKey) => {
	let fileInput;

	return new Promise(resolve => {
		const uploader = file => {
			if (file) {
				const fileName = file.name;
				const formData = new FormData();
				formData.append('files[]', file, fileName);
				formData.append('bid', window.$store.state.bot?.id || window.$store.state.bid || 0);
				formData.append('access_key', accessKey);
				formData.append('rid', reaction.id);
				formData.append('gid', reaction.gid);
				formData.append('aid', reaction.aid);
				formData.append('bid', reaction.bid);
				formData.append('mode', '');
				formData.append('time', +new Date());
				if(reaction.ukey) {
					formData.append('ukey', reaction.ukey);
				}
				upload('/api/sdk', formData, {
					'Authorization': 'Token ' + window.$store.state.auth_token
				}, { useRoot: true }).then(result => {
					if(result && result.files) {
						resolve(result.files);
					} else {
						resolve();
					}
				})
				// .catch(ex => {
				// 	resolve('https://anybot-dev.s3.amazonaws.com/787_1635210699_0.jpeg');
				// });
			} else {
				resolve();
			}

			if(fileInput) {
				fileInput.remove();
				fileInput = undefined;
			}
		}

		if (!file) {
			fileInput = document.createElement('input');
			fileInput.style.display = 'none';
			fileInput.type = 'file';
			fileInput.addEventListener('change', () => {
				const file = fileInput.files?.[0];
				if (file) {
					uploader(file);
				}
			}, false);

			document.body.insertAdjacentElement('beforeend', fileInput);
			fileInput.click();
		} else {
			uploader(file);
		}
	});
}